import { types, getRoot } from 'mobx-state-tree';
import { IRootStore } from 'store/root';

export default types
    .model('LauncherUpdate', {
        scope: types.optional(types.string, ''),
        version: types.optional(types.string, ''),
        region: types.optional(types.string, ''),
    })
    .views(self => ({
        get root(): IRootStore {
            return getRoot<IRootStore>(self);
        },
    }))
    .actions(self => ({
        exec() {
            if (self.region && self.region !== self.root.regionConfig.code) return; // region filter
            switch (self.scope.toLowerCase()) {
                case 'frontend':
                    if (window._FE_version < self.version) {
                        self.root.dialogs.open('LauncherUpdate', { scope: self.scope });
                    }
                    break;
                case 'core':
                    self.root.dialogs.open('LauncherUpdate', { scope: self.scope });
                    break;
            }
        },
    }));
